import $ from 'jquery';

export default () => {
    $(document).ready(function () {
        var lastScrollTop = 0;
        var offset = $("header").outerHeight() + 20;
        $(window).on('scroll', function () {
            var nowScrollTop = $(this).scrollTop();
            if (nowScrollTop > lastScrollTop) {
                $("header").removeClass('blur');
                $("header").css("top", -offset);
            } else {
                $("header").addClass('blur').css("top", 0);
            }
            lastScrollTop = nowScrollTop;
        });
    });
}


// WEBPACK FOOTER //
// ../views/partials/header/header.js